import React, { FC } from 'react';
import { ResultsProps } from '../../../../common/FilterPanelPage/types';

export const ResultsUnmanageable: FC<ResultsProps> = ({ id }) => {
  const testId = `${id}ResultsUnmanageable`;

  return (
    <React.Fragment>
      <div
        className="resultsUnmanageable"
        data-testid={testId}
        data-cy={testId}
      >
        <div className="labelResultsUnmanageable">
          Graph is too large to display or download.
        </div>
      </div>
    </React.Fragment>
  );
};
